module.exports = __webpack_public_path__ + "static/media/stopRecording.aea8cfd2.svg";